import { render, staticRenderFns } from "./maintenance-other-recommend.vue?vue&type=template&id=73fabce8&scoped=true&"
import script from "./maintenance-other-recommend.vue?vue&type=script&lang=js&"
export * from "./maintenance-other-recommend.vue?vue&type=script&lang=js&"
import style0 from "./maintenance-other-recommend.vue?vue&type=style&index=0&id=73fabce8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fabce8",
  null
  
)

export default component.exports